import { Paper as MUIPaper, PaperProps, Typography, TypographyProps } from '@mui/material';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';

interface Props extends PaperProps {
	title?: string;
	titleAlign?: TypographyProps['align'];
}

export const Paper: FunctionComponent<Props> = ({ sx, title, titleAlign, ...props }) => {
	return (
		<MUIPaper
			elevation={0}
			sx={{
				width: '503px',
				padding: 3,
				backgroundColor: ColorPalette.white,
				boxShadow: 'none',
				borderRadius: 5,
				position: 'relative',
				...sx,
			}}
			{...props}
		>
			{title && (
				<Typography
					variant={'h4'}
					align={titleAlign}
					color={ColorPalette.astronaut}
					sx={{ marginBottom: '24px' }}
				>
					{title}
				</Typography>
			)}
			{props.children}
		</MUIPaper>
	);
};
